import React, { Component } from 'react'
import app from '../../feathers'
import { withRouter, Route, Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Switch as Toggle } from 'react-mdl'// Menu, MenuItem,
import Button from '../../components/Button'
import AddEditUserDialog from './AddEditUserDialog'

const TableContainer = styled.div`
  max-height: 660px;
  overflow-y: auto;
`
const Table = styled.table`
  width: 100%;
  border: 1px solid black;
  border-spacing: 0;
  color: #333;
  thead tr {
    background-color: #cccccc;
    height: 25px;
    line-height: 25px;
  }
  tbody tr:nth-child(odd) {
    background-color: #eeeeee;
  }
  tbody td {
    padding: 0.25em;
    vertical-align: middle;
  }
  tr td:first-child,
  tr th:first-child {
    width: 230px
  }
  tr td,
  tr th {
    border-right: 1px solid black;
    text-align: left;
  }
  tr th.check {
    width: 100px;
    text-align: center !important;
  }
  tr td.check {
    padding-left: 35px; // switch doesn't listen to the text-align above
  }
`

const ActionsContainer = styled.div`
  padding: 10px 0;
`

const userService = app.service('users')

class UserListScreen extends Component {
  static contextTypes = { prompt: PropTypes.func }
  state = {
    users: [],
    loading: false,
    savingFeatures: false
  }
  componentDidMount() {
    // listen to changes on the units service
    userService.on('created', this.fetchUsers)
    userService.on('updated', this.fetchUsers)
    userService.on('patched', this.fetchUsers)
    userService.on('removed', this.fetchUsers)

    this.fetchUsers()
  }
  componentWillUnmount() {
    // stop listening to changes on the units service
    userService.off('created', this.fetchUsers)
    userService.off('updated', this.fetchUsers)
    userService.off('patched', this.fetchUsers)
    userService.off('removed', this.fetchUsers)
  }
  fetchUsers = async () => {
    const {
    } = this.state
    const data = await userService.find({
      query: {
        $select: ['firstName', 'lastName', 'email', 'features'],
        // $sort: {
        //   [`${sortField}`]: sortDirection,
        // },
      },
    })
    // if we are out of current bounds and there is then move back in and refetch
    data.forEach(d => {
      d.features = (d.features || {})
    })
    this.setState({ users: data })
  }


  handleTogglePowerpoint = async user => {
    user.features.powerpoint = !(user.features.powerpoint)
    await this.updateFeatures(user);
  }
  handleToggleGenerate = async user => {
    user.features.generateReport = !(user.features.generateReport)
    await this.updateFeatures(user);
  }
  handleToggleAllUnits = async user => {
    user.features.allUnits = !(user.features.allUnits)
    await this.updateFeatures(user);
  }
  handleToggleAssetLibrary = async user => {
    user.features.assetLibrary = !(user.features.assetLibrary)
    await this.updateFeatures(user);
  }
  handleToggleAdministrator = async user => {
    user.features.administrator = !(user.features.administrator)
    await this.updateFeatures(user);
  }

  updateFeatures = async user => {
    await userService.patch(
      user._id,
      { features: user.features },
    )
  }

  resetPassword = async (user) => {
    const response = await this.context.prompt({
      title: 'New Password',
      message: 'Enter new password for ' + user.email,
      inputs: [{
        name: 'password',
        label: 'Password',
        type: 'password'
      }],
      style: {width: '300px'},
      options: [ 'Save', 'Cancel' ]
    })
    if (response.action !== 'Cancel') {
      await userService.patch(
        user._id,
        { password: response.output.password },
      )
    }
  }

  render() {
    const {
      users,
      loading,
    } = this.state

    return (
      <div>
        <Route
          strict
          exact
          path="/users/add"
          component={AddEditUserDialog}
        />
        <Route
          strict
          exact
          path="/users/edit/:userId"
          component={AddEditUserDialog}
        />
        <h3>Users</h3>
        <ActionsContainer>
          <Link to="/users/add">
            <Button raised primary>
              Add New User
            </Button>
          </Link>
        </ActionsContainer>

        <TableContainer>
          {loading ? (
            <p>Loading Users...</p>
          ) : (
              <Table>
                <thead>
                  <tr>
                    <th></th>
                    <th>Firstname</th>
                    <th>Surname</th>
                    <th>Email Address</th>
                    <th className="check">Powerpoint</th>
                    <th className="check">Generate</th>
                    <th className="check">All Units</th>
                    <th className="check">Asset Lib</th>
                    <th className="check">Administrator</th>
                  </tr>
                </thead>
                <tbody>
                  {users.map(user => (
                    <tr key={user._id}>
                      <td>
                        <Link to={`/users/edit/${user._id}`}>
                          <Button>Edit</Button>
                        </Link>
                        <Button onClick={() => this.resetPassword(user)}>Reset Password</Button>
                      </td>
                      <td>
                        {user.firstName}
                      </td>
                      <td>{user.lastName}</td>
                      <td>{user.email}</td>
                      <td className="check">
                        <Toggle
                          onClick={() => this.handleTogglePowerpoint(user)}
                          checked={user.features.powerpoint}
                        ></Toggle>
                      </td>
                      <td className="check">
                        <Toggle
                          onClick={() => this.handleToggleGenerate(user)}
                          checked={user.features.generateReport}
                        ></Toggle>
                      </td>
                      <td className="check">
                        <Toggle
                          onClick={() => this.handleToggleAllUnits(user)}
                          checked={user.features.allUnits}
                        ></Toggle>
                      </td>
                      <td className="check">
                        <Toggle
                          onClick={() => this.handleToggleAssetLibrary(user)}
                          checked={user.features.assetLibrary}
                        ></Toggle>
                      </td>
                      <td className="check">
                        <Toggle
                          onClick={() => this.handleToggleAdministrator(user)}
                          checked={user.features.administrator}
                        ></Toggle>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
        </TableContainer>
      </div>
    )
  }
}

export default withRouter(UserListScreen)



// WEBPACK FOOTER //
// ./src/Users/UserListScreen/index.js